import Vue from 'vue';
import model from './showModal.vue';


export default {
    install(Vue) {
        const defaults = {
            show: false,
            mask: true,
            title: '提示',
            content: '这是正文',
            confirmButton: true,
            cancelButton: true,
            confirmText: '确认',
            cancelText: '取消',
            cancelCallBack: () => {},
            confirmCallBack: () => {}
        };

        const modelVueConstructor = Vue.extend(model);

        Vue.prototype.$showModal = (options = {}) => {

            options = Object.assign({}, defaults, options);
            let parent = document.body ;
            let instance = new modelVueConstructor({
                el: document.createElement('div'),
                data: options
            });
            parent.appendChild(instance.$el);

            return instance;
        };

    },
};